class QueryBroadcastChannel {
  private static channelId = "QUERY_BRADCAST_CHANNEL";
  private static channel: BroadcastChannel | null = null;

  public static getChannel(): BroadcastChannel {
    if (QueryBroadcastChannel.channel === null) {
      QueryBroadcastChannel.channel = new BroadcastChannel(QueryBroadcastChannel.channelId);
    }
    return QueryBroadcastChannel.channel;
  }
}

export const queryBroadcastChannel = QueryBroadcastChannel.getChannel();

// 다른 탭에서 쿼리 캐시를 삭제하기 위한 함수 (스킴링크로 띄운 새 탭)
export function invalidateQueriesOtherTabs(queryKey: string[]) {
  queryBroadcastChannel.postMessage(queryKey);
}
